<template>
  <div class="row">
    
    <div class="col-md-6">
      <div class="card card-table flex-fill" data-tour-step="dashboard-daily">
        <div class="card-header">
          <h3 class="card-title mb-0">Statistik Harian</h3>
        </div>
        <div class="card-body">

          <grafik   
          :series="series"
          :categories="categories"
          :colors="colors"
          :height="420"
          :dataLabels="false"
          :stacked="true"/>
        </div>
        <div class="card-footer" v-if="rows.length > 0">
          <router-link to="broadcast-v2">Lihat Semua Broadcast</router-link>
        </div>
      </div>
    </div>
    
    <div class="col-md-6 d-flex">
      <div class="card flex-fill" data-tour-step="dashboard-schedule">
        <div class="card-body">
          <h4 class="card-title">
            Jadwal Broadcast
            <span class="badge bg-inverse-success ml-2" v-if="!isLoadingSchedule">{{ totalRecordSchedule }}</span>
          </h4>
          <template v-if="isLoadingSchedule">
            <div class="leave-info-box">
              <div class="media align-items-center">
                <span class="avatar">
                  <Skeleton :count="1" />
                </span>
                <div class="media-body">
                  <div class="text-sm my-0">
                    <Skeleton :count="1" />
                  </div>
                </div>
              </div>
              <div class="row align-items-center mt-3">
                <div class="col-6">
                  <h6 class="mb-0">
                    <Skeleton :count="1" />
                  </h6>
                  <span class="text-sm text-muted">
                    <Skeleton :count="1" />
                  </span>
                </div>
                <div class="col-6 text-right">
                  <span class="badge bg-inverse-success">
                    <Skeleton :count="1" />
                  </span>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="leave-info-box" v-for="(row, idx) in rowsSchedule" :key="idx">
              <div class="media align-items-center">
                <span class="avatar" v-if="row.message_type == 'image'">
                  <img alt :src="row.message_media" />
                </span>
                <span class="avatar" v-if="row.message_type == 'file'">
                  <img alt src="@/assets/attachment.png" />
                </span>
                <div class="media-body">
                  <div class="text-sm my-0">
                    <router-link :to="'/broadcast-info-v2?id=' + row.id">{{ row.title }}</router-link>
                  </div>
                </div>
              </div>
              <div class="row align-items-center mt-3"
                v-if="row.sending_options == 2 && row.sending_schedule > currentDateTimeUnix()">
                <div class="col-6">
                  <h6 class="mb-0">{{ formatLocalDateWithDay(row.sending_schedule) }}</h6>
                  <span class="text-sm text-muted">Scheduled</span>
                </div>
                <div class="col-6 text-right">
                  <span class="badge bg-inverse-success">Active</span>
                </div>
              </div>
              <div class="row align-items-center mt-3" v-if="row.is_recurring == 1">
                <div class="col-6">
                  <h6 class="mb-0">
                    <i class="fa fa-clock-o"></i>
                    {{ row.recurrence }}
                    <br />
                    time: {{ formatHourFromUnix(convertUTCDatetimeToUnix(row.recurrence_time)) }}
                  </h6>
                  <span class="text-sm text-muted">Recurring</span>
                </div>
                <div class="col-6 text-right">
                  <span class="badge bg-inverse-success">Active</span>
                </div>
              </div>
            </div>
          </template>

          <div class="load-more text-center" v-if="!isLoadingSchedule && totalRecordSchedule > 0">
            <router-link to="/broadcast-v2">Lihat Jadwal
              Broadcast</router-link>
          </div>
          <div class="load-more text-center" v-if="!isLoadingSchedule && totalRecordSchedule == 0">
            <router-link to="/broadcast-wizard-v2">Buat Broadcast Baru</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import grafik from "./grafik.vue";
import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid,
  convertUTCDatetimeToUnix,
  formatHourFromUnix
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    grafik
  },
  data() {
    return {
      baseUrl:process.env.VUE_APP_BASE_URL,
      loadingResendAnomali: false,
      message_anomali: "",
      totalRecordSchedule: 0,
      rowsSchedule: [],
      isLoadingSchedule: false,
      serverParamsSchedule: {
        columnFilters: {
          license_id: "",
          period: "",
          is_send: "running",
          is_running: "all"
        },
        page: 1,
        perPage: 10 // perPage
      },
      rows: [],
      isLoading: false,
      serverParams: {
        columnFilters: {
          license_id: "",
          period: "",
          is_send: "",
          is_running: ""
        },
        page: 1,
        perPage: 10 // perPage
      },
      colors: [
        '#6c757d', // destination - abu-abu (bootstrap secondary)
        '#ffc107', // pending - kuning (bootstrap warning)
        '#dc3545', // error - merah (bootstrap danger)
        '#28a745'  // success - hijau (bootstrap success)
      ]
    };
    //  isactive : true
  },
  computed: {
    series () {
      // kita harus memastikan nilai numeric (parseInt)
      const dest = { name: 'Destination', data: [] }
      const pending = { name: 'Pending', data: [] }
      const error = { name: 'Error', data: [] }
      const success = { name: 'Success', data: [] }

      this.rows.forEach(item => {
        // parse ke number, fallback 0
        const d = Number(item.destination_num) || 0
        const p = Number(item.pending_num) || 0
        const e = Number(item.error_num) || 0
        const s = Number(item.success_num) || 0

        dest.data.push(d)
        pending.data.push(p)
        error.data.push(e)
        success.data.push(s)
      })

      // urutan series harus sesuai urutan colors yang dikirimkan
      return [dest, pending, error, success]
    },
    
    categories () {
      return this.rows.map(item => item.title)
    },
  },
  async created() {
    this.loadItems();
    this.loadItemsSchedule();
  },
  methods: {
    substringTitle(bc_title){
      let limit = 40;
      if(bc_title.lenght>limit){
        return bc_title.substring(0,limit)+"..."
      }
      return bc_title

    },
    async checkAnomaliBroadcast(id) {
      this.isLoading = true;
      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      // let formData = await {};
      await this.$store
        .dispatch("omniwa/checkAnomaliBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          // var { data } = response;
          // console.log(response)
          if (response['data']['status'] == 0) {
            // this.message_anomali = response['msg']
            // console.log(" this.$refs['anomali'+id]", this.$refs['anomali_' + id])
            this.$refs['anomali_' + id][0].innerHTML = "<a href='"+this.baseUrl+"/broadcast-info-v2?id=" + id + "' class='text text-danger'><blink><b>WARNING!!</b></blink></a>"
          }

        });

    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    calculatePercent(row) {
      let numDest = parseInt(row.destination_num);
      let numSuccess = parseInt(row.success_num);
      let numPending = parseInt(row.pending_num);
      let numError = parseInt(row.error_num);
      // console.log("row",row)
      // console.log(" (numDest / (numSuccess + numError))", numDest,numSuccess ,numError)
      let percent = ((numSuccess + numError) / numDest ) * 100;
      // console.log("percent",percent)

      // let percent = (numPending / (numSuccess + numError)) * 100;
      if (percent > 100) {
        return 100;
      } else {
        return Math.floor(percent);
      }
    },
    async loadItemsSchedule() {
      this.isLoadingSchedule = await true;
      this.serverParamsSchedule.page =
        this.serverParamsSchedule.page - 1 <= 0
          ? await 0
          : await ((this.serverParamsSchedule.page - 1) *
            this.serverParamsSchedule.perPage);

      await this.$store
        .dispatch("messageReport/listBroadcastV2", this.serverParamsSchedule) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecordSchedule = data.totalRecords;
          this.rowsSchedule = data.data;
          this.isLoadingSchedule = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async loadItems() {
      this.isLoading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("messageReport/listBroadcastV2", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.rows = data.data.map(i => {
            return {
                title:i.title.length > 20 ? i.title.substring(0, 20) + '...' : i.title,
                destination_num:i.destination_num,
                pending_num:i.pending_num,
                error_num:i.error_num,
                success_num:i.success_num,
            }
          }); 
          // this.rows.forEach((rowBc, idx) => {
          //   if ((rowBc.sending_options !== 2 || rowBc.sending_schedule < this.currentDateTimeUnix()) && rowBc.last_sent_datetime > 0) {
          //     this.checkAnomaliBroadcast(rowBc.id)
          //   }
          // })
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  mounted() { },
  name: "recentBroadcast"
};
</script>


// WEBPACK FOOTER //
// src/views/dashboard/components/graphBroadcast.vue